const ProfileCard = ({ emp }) => {
  const reportTo = emp.manager_name || emp.manager || "Venkatesh S";

  return (
    <div className="profile-card">
      <div className="profile-left">
        <div className="profile-avatar">
          {emp.first_name?.charAt(0)}
        </div>
        <div>
          <h1 className="profile-name">{emp.first_name} {emp.last_name}</h1>
          <p className="profile-role">{emp.designation}</p>
        </div>
      </div>

      <div className="profile-right">
        <div className="profile-info">
          <span>Employee Code:</span> <p className="blue">{emp.emp_code}</p>
        </div>
        <div className="profile-info">
          <span>Department:</span> <p className="blue">{emp.department}</p>
        </div>
        <div className="profile-info">
          <span>Reports To:</span> <p className="blue">{reportTo}</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
